import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';

interface ProfileFetchResponse {
  email: string;
  sectorsDbNames: string[];
  uuid: string;
  name: string;
}

interface User {
  uuid: string;
  email: string;
  token: string;
  sectors: string[];
  name: string;
}

@Injectable({ providedIn: 'root' })
export default class AuthService {
  private http = inject(HttpClient);

  #localStorageKey = 'user';
  private user = new BehaviorSubject<User | null>(this.loadFromStorage());

  private loadFromStorage(): User | null {
    const raw = localStorage.getItem(this.#localStorageKey);

    if (!raw) return null;

    const user: User = JSON.parse(raw);

    return user;
  }

  get currentUser() {
    this.loadFromStorage();
    return this.user.value;
  }

  setUser(user: User) {
    localStorage.setItem(this.#localStorageKey, JSON.stringify(user));
    this.user.next(user);
  }

  logout() {
    localStorage.removeItem(this.#localStorageKey);

    this.user.next(null);
  }

  fetchMe(token: string) {
    return this.http.get<ProfileFetchResponse>(environment.backUrl + '/api/me', {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + token,
      }),
    });
  }
}
